/**
 * @description: JS语法垫片：在相对低版本的游览器中运行高于当前游览器版本支持的JS语法。通过模拟的方式来实现低版本兼容
 */

const isBrowserSupport = (objType, functionName) => {
	return !!objType.prototype[functionName];
};

// 监测find语法
if (!isBrowserSupport(Array, 'find')) {
	Array.prototype.find = function (fn) {
		if (typeof fn !== 'function') {
			throw new TypeError(`${fn} is not a function`);
		}
		for (let i = 0; i < this.length; i++) {
			if (fn(this[i])) return this[i];
		}
	};
}



// WEBPACK FOOTER //
// ./src/lib/shimming.js